var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46356 1.43051e-06C2.4482 1.43051e-06 0 2.4482 0 5.46357C0 6.3419 0.457377 7.57979 1.12575 8.87257C2.59857 11.7209 5.05224 14.8882 5.05224 14.8882C5.15084 15.0154 5.30278 15.0898 5.46356 15.0898C5.62435 15.0898 5.77629 15.0154 5.87489 14.8882C5.87489 14.8882 8.32855 11.7209 9.80138 8.87257C10.4698 7.57979 10.9271 6.3419 10.9271 5.46357C10.9271 2.4482 8.47893 0 5.46356 0V1.43051e-06ZM5.46356 3.12204C4.1713 3.12204 3.12204 4.1713 3.12204 5.46357C3.12204 6.75583 4.1713 7.80509 5.46356 7.80509C6.75583 7.80509 7.80509 6.75583 7.80509 5.46357C7.80509 4.1713 6.75583 3.12204 5.46356 3.12204Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9bfda36864a87a7350c56fc2f190fb86.svg";
export { ForwardRef as ReactComponent };